import React, { Component } from 'react';
import { translate } from 'react-i18next';

class Balance extends Component {

  renderFullBalance = () => {
    const { t } = this.props;
    return (
      <div>
        <label>Factura a Pagar</label>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>{t('dashboard.invoices.col_remission')}</th>
              <th>Saldo a pagar</th>
              <th>Tipo de cambio</th>
              <th>Saldo a pagar en MXN</th>
            </tr>
          </thead>
          <tbody>
            {this.props.get_data_invoives_page.map((invoice, index) =>
              <tr key={index}>
                <td>{invoice.remission}</td>
                <td>{"$" + parseFloat(invoice.balance.toFixed(4)).toLocaleString("en-US")+ " " + invoice.balance_cur}</td>
                <td>{invoice.balance_cur === "USD" ? parseFloat(invoice.total_rate.toFixed(2)).toLocaleString("en-US") + "MXN" : "N/A"}</td>
                <td>{"$" + parseFloat(invoice.total_mxn.toFixed(4)).toLocaleString("en-US")+ " MXN"}</td>
              </tr>


            )}
            <tr>
              <td>Total: </td>
              <td></td>
              <td></td>
              <td>{"$" + parseFloat(this.props.total_invoices.toFixed(4)).toLocaleString("en-US") + " MXN"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    const { t } = this.props;

    return (
      <div className="table-responsive">
        {this.renderFullBalance()}
      </div>
    )
  }
}

export default translate('common')(Balance);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/Balance.js